const developerTools = [
  "Git",
  "Docker",
  "Kubernetes",
  "Azure Cloud",
  "Google Cloud",
  "Google Colab",
  "Microsoft 365",
  "RabbitMQ",
  "Selenium",
  "JUnit",
  "Databricks"
];

export default developerTools;